import React, { useEffect, useState } from 'react'
import { Col, Row, Spinner, Stack } from 'react-bootstrap'
import SVG from 'react-inlinesvg'
import Chart from 'react-apexcharts'
import ApprovedIcon from '../../../../_metronic/images/ApprovedIcon.svg'
import PendingIcon from '../../../../_metronic/images/PendingIcon.svg'
import RejectedIcon from '../../../../_metronic/images/RejectedIcon.svg'
import { chartOptions } from '../../../../utils/helper'

interface Props {
  data?: any
  reload: boolean
}


type QCStatus = 'ACCEPTED' | 'REJECTED' | 'PENDING';

interface TPVStatusItem {
  qcStatus: QCStatus;
  qcStatusCount: number;
}

const TpvReport = ({ data, reload }: Props) => {

  const [approved, setApproved] = useState<number>()
  const [rejected, setRejected] = useState<number>()
  const [pending, setPending] = useState<number>()
  const [qcTpvSeries, setQcTpvSeries] = useState<any>()


  useEffect(() => {
    if (!data?.tpvStatus) {
      return;
    }

    const statusCount: Record<QCStatus, number> = {
      ACCEPTED: 0,
      REJECTED: 0,
      PENDING: 0,
    };

    const updatedQcSeries: number[] = [];

    (data.tpvStatus as TPVStatusItem[]).forEach(({ qcStatus, qcStatusCount }) => {
      if (qcStatus in statusCount) {
        statusCount[qcStatus] = qcStatusCount;
        updatedQcSeries.push(qcStatusCount);
      }
    });

    setApproved(statusCount.ACCEPTED);
    setRejected(statusCount.REJECTED);
    setPending(statusCount.PENDING);
    setQcTpvSeries(updatedQcSeries);
  }, [data]);




  const tpvReportOptions: Object = chartOptions(['Approved', 'Pending', 'Rejected'], ['#50CD89', '#F6C000', '#F1416C'])

  return (
    <>
      <div className='card card-flush card-border mb-5 mb-xl-110 h-auto' style={{ minHeight: '368px', maxHeight: '368px' }}>
        <Stack className='container mt-8 mb-5 ms-4'>
          <div className='text-dark fw-bolder fs-3'>
            QC Status
          </div>
        </Stack>
        {reload ? (
          <div className="text-center align-items-center mb-20">
            <Spinner animation="border" className="text-gray-600 text-center" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>) : (
          <div className='container mt-5'>
            <Row>
              <Col sm md lg='7'>
                <div className='d-flex flex-center mb-7 position-relative'>
                  <Chart
                    type='donut'
                    height={280}
                    width={330}
                    series={qcTpvSeries}
                    options={tpvReportOptions}
                  />
                </div>
              </Col>
              <Col sm md lg='5' className='align-self-center mb-5'>
                <Stack gap={5}>
                  <div className='d-flex me-15 mb-4'>
                    <SVG src={ApprovedIcon} className='me-3' />
                    <Stack>
                      <span className='fw-bold fs-2'>{approved}</span>
                      <span className='text-success fs-6'>Accepted</span>
                    </Stack>
                  </div>
                  <div className='d-flex me-15 mb-4'>
                    <SVG src={PendingIcon} className='me-3' />
                    <Stack>
                      <span className='fw-bold fs-2'>{pending}</span>
                      <span className='text-warning fs-6'>Pending Review</span>
                    </Stack>
                  </div>
                  <div className='d-flex me-15 mb-4'>
                    <SVG src={RejectedIcon} className='me-3' />
                    <Stack>
                      <span className='fw-bold fs-2'>{rejected}</span>
                      <span className='text-danger fs-6'>Rejected</span>
                    </Stack>
                  </div>
                </Stack>
              </Col>
            </Row>
          </div>
        )}
      </div>
    </>
  )
}

export default TpvReport

